import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/consignment-stock-out/")({
	component: () => null,
});
